// extracted by mini-css-extract-plugin
export default {"component":"W5AhR","withIcon":"reWFz","input":"AYs7U","fail":"IRbg7","big":"ZjsV6"};